import { render, staticRenderFns } from "./Shelterinfo.vue?vue&type=template&id=7bdd0d4e&"
import script from "./Shelterinfo.vue?vue&type=script&lang=js&"
export * from "./Shelterinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports